var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", staticStyle: { position: "relative" } },
    [
      !_vm.openMultiple
        ? _c("booking-tree-grid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.view === "list",
                expression: "view==='list'"
              }
            ],
            ref: "bookingTreeGrid",
            attrs: {
              context: _vm.context,
              "is-query": _vm.isQuery,
              "is-fba": _vm.isFba
            },
            on: {
              look: _vm.lookHandle,
              edit: _vm.editHandle,
              add: _vm.addHandle,
              split: _vm.splitHandle,
              copy: _vm.copyHandle
            }
          })
        : _vm._e(),
      _c("booking-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "bookingWorkspace",
        attrs: {
          "parent-context": _vm.context,
          "open-multiple": _vm.openMultiple,
          "is-fba": _vm.isFba,
          view: _vm.view
        },
        on: {
          add: _vm.addHandle,
          copy: _vm.copyHandle,
          back: _vm.backToList,
          refreshList: _vm.refreshList,
          chargeLockStatusChange: _vm.chargeLockStatusChange
        }
      }),
      _c("sea-booking-copy-window", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.copyDialog.visible,
            expression: "copyDialog.visible"
          }
        ],
        ref: "seaBookingCopyWindow",
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || "",
          "is-master": _vm.copyDialog.job.masterFlag || false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _c("job-no-rule-selector", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.jobNoRule.visible,
            expression: "jobNoRule.visible"
          }
        ],
        ref: "jobNoRuleSelector",
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }